  import React from "react";
  import Dropzone from "react-dropzone";
  import FontAwesome from "react-fontawesome";
  import Papa from "papaparse";
  import _ from "underscore";
  import { connect } from "react-redux";
  import { bindActionCreators } from "redux";
  import axios from 'axios';
  import {
    addUploadedClaims,
    addViewClaims,
    setUploadCheck,
    isRecentBatch
  } from "./actions";
  import img from '~/assets/icn-cancel-copy.svg';
  import toastr from 'toastr';
  import { cvsHeader, mergeLineItems } from "~/app/utilities/index";
  import { kinetik_api_url } from "~/app/utilities/const";
  import { addQueudedClaims } from "~/app/submit_claims/claims_table/actions";


  class Upload extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        fileNames: this.getFileNames(),
        claimFiles: []
      };
    }
    getFileNames=()=>{
      const uploadedClaims = this.props.uploaded_claims;
      
      let fileNames = []
      _.each(uploadedClaims, claim =>{
        fileNames.push(claim[0].file_name)
      })
      return fileNames
    }
    render() {
      const highlightToggle= this.props.is_recent_batch;
      return (
        <div className={this.highlightBox(highlightToggle)}>
          <div className="box-header">
            <div className="header-name">Upload Claims</div>
            {this.renderHeaderContent()}
          </div>
          <div className="box-content">{this.renderDropArea()}</div>
        </div>
      );
    }
    
    highlightBox = (highlightToggle) => {
      if (highlightToggle) { return "small-box left" }
      else {
        return "small-box left box-highlight"
      }
    }

    renderHeaderContent = () => {
      if (this.state.fileNames.length !== 0) {
        return (
          <div className="upload-header">
            <FontAwesome
              className="icon-eye-upload"
              name="eye"
              onClick={this.viewUploadedClaim}
            />
            <FontAwesome
              className="icon-cancel-upload"
              name="times-circle"
              onClick={this.handleClearAll}
            />
          </div>
        )
      }
      }
      
    onDrop = files => {
      // let count = 0;
      _.each(files, async file => {
        const fileExt = file.name.substring(file.name.length - 3);
        const isDuplicate = await this.checkFileInDB(file.name);
        if (isDuplicate) return toastr.error("This file was already uploaded. Check the uploaded files section")
        if (fileExt !=="csv" && fileExt !=="txt" && fileExt !=="837" && fileExt !=="x12" ){
          toastr.error(file.name+" is not a valid file");
        } else {
          Papa.parse(file, {
            header: true,
            complete: async results => {
              if (results.data.length === 0) {
                results.data = await this.parse837(results.meta.fields[0]);
              }
              //Removes row with empty values and spaces. 
              if (!_.isEmpty(results.errors)){
                _.each(results.errors, error => {
                  results.data.splice(error.row, 1)
                })
              }
              const verified=this.verifyCSV(results, file);
              if(!verified) return 0;
              //if (count >= files.length - 1) {
                this.props.setUploadCheck(true)
                this.props.addUploadedClaims(this.state.claimFiles);
                const combinedClaims = _.flatten(this.props.uploaded_claims);
                this.props.addViewClaims(combinedClaims);
                this.props.isRecentBatch(false);
              // } else {
              //   count++;
              // }
            }
          });
        }
       
      });
    };


    parse837 = async (string837) => {
      return axios.post(kinetik_api_url + "/edi/837/parse", { data: string837 }).then(res => {
        return res.data;
      }).catch(err=>{
        console.log("err parsing 837",err);
      })
    }

    uploadToDB=(claimsFile)=>{
      const token = localStorage.getItem('authToken');
     axios.post(kinetik_api_url+"/file/upload",{claimsFile,token}).then(res=>{
     }).catch(err=>{
       console.log("Err from file upload to DB",err);
     })
    }

    checkFileInDB=async (file_name)=>{
      const token = localStorage.getItem('authToken');
      return axios.get(kinetik_api_url+"/file/"+file_name+'?token='+token).then(res=>{
       return (res.data!==null)?true:false;
      })
    }

    verifyCSV = (results, file) => {
      const keys = Object.keys(results.data[0]);
      const csvCheck = _.difference(cvsHeader, keys);
      //if correct file
      let fileName = file.name.replace(/#|\(|\)|\$|\s/g, "");
      //check payerID
      const validPayerID = this.payerIDCheck(results.data);
      if(!validPayerID){
        toastr.error("Payer ID not found. Please check the uploaded CSV");
        return false;
      }
      if (csvCheck.length === 0) {
        this.setState({ fileName: this.state.fileNames.push(fileName) });
        const mergedBatch = mergeLineItems(results.data, fileName,this.props.provider_info);
        this.uploadToDB(mergedBatch);

        let currentClaims = this.state.claimFiles;
        
        currentClaims.push(mergedBatch);
        this.setState({ claimFiles: currentClaims });
        return true
      }else{
        toastr.error("Please make sure the file"+file.name+" has the proper headers")
        return false
      }

    };

    payerIDCheck(claims){
      const payers = this.props.provider_info.company_payers;
      console.log("payers",payers);
      for (let i=0;i<claims.length;i++){
        const payer_id = claims[i].payer_id;
        console.log("payerid",claims[i].payer_id)
        if(payer_id!=="" && payer_id != null ){
          const match =_.findWhere(payers,{value:claims[i].payer_id})
          if(match===undefined){ // not found
            return false;
          }
        }
       
      }        
      return true;
    }

    viewUploadedClaim = () => {
      this.props.addViewClaims(_.flatten(this.props.uploaded_claims));
      this.props.isRecentBatch(false);
    };
    handleClearAll = () => {
      this.props.addUploadedClaims([]);
      this.setState({ fileNames: [],claimFiles:[] });
      this.props.addViewClaims([]);
      this.props.addQueudedClaims([]);
      this.props.isRecentBatch(false);
    };

    renderDropArea = () => {
      if (this.state.fileNames.length === 0) {
        return (
          <Dropzone className="dropzone" onDrop={this.onDrop}>
            <FontAwesome className="icon-cloud" name="cloud-upload" />
            <p className="upload-txt">
              Drag and Drop CSV/837p here <br /> <span>or</span>
            </p>
            <button type="button" className="btn btn-primary upload-btn">
              Browse Files
            </button>
          </Dropzone>
        );
      } else {
        return (
          <div>
              <div className="file-wrapper">
                <div> {this.renderUploadedFiles()}</div>
            </div>
          </div>
        );
      }
    };


    renderUploadedFiles = () => {
      return <div>{this.renderEachFile()}</div>;
    };
    handleCancel = index => {
      let newFileNames = this.state.fileNames;
      newFileNames.splice(index, 1);
      this.setState({ fileNames: newFileNames });

      let newClaimFiles = this.state.claimFiles;
      newClaimFiles.splice(index, 1);
      this.setState({ claimFiles: newClaimFiles });
      this.props.addUploadedClaims(newClaimFiles);
      const combinedClaims = _.flatten(newClaimFiles);
      this.props.addViewClaims(combinedClaims);
      this.props.isRecentBatch(false);
    };

    renderEachFile(){
      return this.state.fileNames.map((fileName, index) => {
        return (
          <div key={index} className="uploaded-csv">
            <img alt="icon-csv" className="icon-csv" src="data:image/svg+xml;utf8;base64,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" />
            <span>{fileName}</span>
            <div className="right"><img
              alt="Delete File"
              src={img}
              onClick={() => this.handleCancel(index)}
              className="icon-cancel"
              name="times-circle-o"
            /></div>
            
          </div>
        );
      });
    }
  }

  const mapStateToProps = state => {
    return {
      uploaded_claims: state.submitClaims.uploaded_claims,
      is_recent_batch: state.submitClaims.is_recent_batch,
      provider_info: state.userData.provider_info
    };
  };

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        addUploadedClaims: addUploadedClaims,
        addViewClaims: addViewClaims,
        isRecentBatch:isRecentBatch, 
        setUploadCheck: setUploadCheck,
        addQueudedClaims: addQueudedClaims
      },
      dispatch
    );
  }

  export default connect(mapStateToProps, mapDispatchToProps)(Upload);



// WEBPACK FOOTER //
// ./src/app/submit_claims/upload/Upload.js